import { ILocationGroup } from '~/services/api/locationGroups/types';
import { IOption } from '~/types';

export default (locationGroups: ILocationGroup[]): IOption[] =>
  locationGroups.map(item => ({ value: item.id, label: item.name }));
